<template>
  <div class="cart-template__footer-attributes">
    <div class="cart-template__packaging">
      <p
        id="complimentary-packaging"
        class="body-small"
      >
        {{ packagingLabel }}
      </p>
      <div class="cart-template__packaging-options">
        <button
          v-for="(option, index) in packagingOptions"
          :key="index"
          :class="{ active: option === selectedPackaging }"
          type="button"
          aria-labelledby="complimentary-packaging"
          @click="updatePackaging(index)"
        >
          {{ option }}
        </button>
      </div>
      <input
        v-model="selectedPackaging"
        type="hidden"
        name="attributes[packaging]"
      >
    </div>
    <div
      v-if="displayNote"
      class="cart-template__note"
    >
      <div class="form-group">
        <div class="form-group__control" :class="selectionStatus">
          <input
            id="add-note"
            v-model="addNote"
            class="input--checkbox"
            type="checkbox"
            name="add-note"
            @change="addNoteOption"
          >
          <label for="add-note">{{ addNoteText }}</label>
        </div>
      </div>
      <transition name="slide-vertical">
        <div
          v-if="addNote"
          class="form-group"
        >
          <label
            class="form-label visually-hidden"
            for="cart-note"
          >{{ cartNoteLabel }}</label>
          <textarea
            id="cart-note"
            v-model="note"
            name="note"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    displayNote: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    const packagingOptions = [window.theme.strings.cart.general.gift_bag, window.theme.strings.cart.general.minimal_packaging];

    return {
      addNote: false,
      note: '',
      packagingOptions,
      selectedPackaging: '',
    };
  },

  computed: {
    ...mapState({
      cartNote: (state) => state.cart.note,
      cartAttributes: (state) => state.cart.attributes,
    }),

    addNoteText() {
      return window.theme.strings.cart.general.add_note;
    },

    cartNoteLabel() {
      return window.theme.strings.cart.general.note_label;
    },

    packagingLabel() {
      return window.theme.strings.cart.general.packaging;
    },
    selectionStatus() {
      return this.addNote ? 'selected' : 'not-selected';
    }
  },

  watch: {
    cartAttributes({ packaging }) {
      if (packaging) {
        this.selectedPackaging = packaging;
      } else {
        this.selectedPackaging = this.packagingOptions[0];
        this.updatePackaging(0);
      }
    },

    cartNote(note) {
      this.addNote = !!note;
      this.note = note;
    }
  },

  methods: {
    ...mapActions({
      updateNote: 'cart/updateNote',
      updateAttributes: 'cart/updateAttributes',
    }),

    addNoteOption() {
      if (!this.addNote) {
        this.updateNote('');
      }
    },

    updatePackaging(index) {
      this.selectedPackaging = this.packagingOptions[index];
      this.updateAttributes({
        attributes: {
          packaging: this.selectedPackaging
        }
      });
    },
  },
}
</script>

<style>

</style>